import noImagePlaceholder from 'assets/no-image-placeholder'
import {BlobDto, BlobUpload, Optional} from 'data/types'
import ImgixClient from 'imgix-core-js'
import services from 'services'

export default function getImageSrcFromBlob(blob: Optional<BlobUpload | BlobDto>, imgixOptions?: any) {
  if (blob == null) {
    return noImagePlaceholder
  }
  if ('filename' in blob) {
    if (imgixOptions) {
      // @ts-ignore
      let client: ImgixClient = getImageSrcFromBlob.imgixClient
      if (!client) {
        client = new ImgixClient({
          domain: services.config.imgixDomain,
        })
        // @ts-ignore
        getImageSrcFromBlob.imgixClient = client
      }
      return client.buildURL(blob.filename, {
        ...imgixOptions,
        dpr: 2,
      })
    }

    return blob.url
  }
  switch (blob.contentType) {
    case 'image/jpeg':
      return `data:image/jpg;base64,${blob.content}`
    case 'image/jpg':
      return `data:image/jpg;base64,${blob.content}`
    case 'image/png':
      return `data:image/png;base64,${blob.content}`
    case 'image/gif':
      return `data:image/gif;base64,${blob.content}`
  }
}
